export default __webpack_public_path__ + "static/media/QR Code-IOS.08c9c2df.jpeg";